import { createContext } from "react";

const plataformaTenantContext = createContext();

export default plataformaTenantContext;
